import React from 'react';
import '../less/routine-work.less';
import DOMPurify from 'utils/sanitize';
import {Preloader} from 'MWComponents';
import {canUseDOM} from '../../../../../helpers/canUseDOM';

export default function template() {
  const {widgets_routine_work, widgets_routine_work_loading} = this.props;

  const widget = widgets_routine_work && widgets_routine_work.find(w => w.code === 'universal_element');
  const items = widget && widget.data
    ? [...widget.data].sort((a, b) => {
        if (a.order == null && b.order == null) return 0;
        if (a.order == null) return 1;
        if (b.order == null) return -1;
        return b.order - a.order;
      })
    : [];

  return (
      <div className="routine-work-page">
        <div className="content">
          <div className="container">
            <h1 className="routine-work-page__title">{this.l10n('ROUTINE_WORK_TITLE')}</h1>
            <div className="routine-work__body">
              {widgets_routine_work_loading ? (
                canUseDOM ? <Preloader /> : null
              ) : (
                items.length > 0 ? (
                  items.map((item, index) => (
                    <div key={index} className="routine-work__item item-routine-work">
                      <div className="item-routine-work__top">
                        {item.title && <div className="item-routine-work__title" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.title)}}></div>}
                        {item.published_at && <div className="item-routine-work__date routine-work-text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.published_at)}}></div>}
                      </div>
                      {item.description && <div className="item-routine-work__text routine-work-text" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(item.description)}}></div>}
                    </div>
                  ))
                ) : ( 
                  <div className="routine-work-text">{this.l10n('ROUTINE_WORK_TEXT_NO_ANNOUNCEMENTS')}</div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
  );
}
